import app from "../firebase";
import { getFunctions, httpsCallable } from "firebase/functions";

const callOperatorAction = async (tenantId, portalAction, data = {}) => {
  if (!tenantId) throw new Error("Müşteri çalışma alanı belirlenemedi.");
  const callable = httpsCallable(
    getFunctions(app, "us-central1"),
    "portalCredentials"
  );
  const response = await callable({
    credentialScope: { kind: "tenant", tenantId },
    portalAction,
    ...data
  });
  return response.data;
};

export const getVioOperatorOverview = (tenantId) =>
  callOperatorAction(tenantId, "operatorList");

export const testVioOperatorConnection = (tenantId, connectionId) =>
  callOperatorAction(tenantId, "operatorConnectionTest", { connectionId });

export const getVioOperatorLoginPassword = async (tenantId, connectionId) => {
  const result = await callOperatorAction(tenantId, "reveal", { id: connectionId });
  return String(result?.password || "");
};

export const syncVioOperatorSnapshot = (tenantId, connectionId, snapshot) =>
  callOperatorAction(tenantId, "operatorSyncSnapshot", { connectionId, snapshot });

export const importVioOperatorMasterData = (tenantId, connectionId, snapshot) =>
  callOperatorAction(tenantId, "operatorImportMasterData", { connectionId, snapshot });

export const createVioOperatorDraft = (tenantId, data) =>
  callOperatorAction(tenantId, "operatorCreateDraft", data);

export const approveVioOperatorJob = (tenantId, jobId) =>
  callOperatorAction(tenantId, "operatorApprove", { jobId });

export const markVioOperatorJobPrepared = (tenantId, jobId, preparation) =>
  callOperatorAction(tenantId, "operatorMarkPrepared", { jobId, preparation });

export const verifyVioOperatorJob = (tenantId, jobId, verification) =>
  callOperatorAction(tenantId, "operatorVerify", { jobId, verification });

export const cancelVioOperatorJob = (tenantId, jobId) =>
  callOperatorAction(tenantId, "operatorCancel", { jobId });
